/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Painting = 1, Roofing = 2, Siding = 3, Windows = 4, Gutters = 5, Flooring = 6, Plumbing = 7, Electrical = 8, Hvac = 9, Landscaping = 10, PestControl = 11, Fencing = 12, Decks = 13, Concrete = 14, Masonry = 15, Remodeling = 16, Cleaning = 17, Handyman = 18, Solar = 19, Pools = 20, GarageDoors = 21, TreeService = 22, PressureWashing = 23, Insulation = 24, Drywall = 25, Foundation = 26, Irrigation = 27, Other = 99
 */
export enum Routemize_Constants_ServiceCategory {
    PAINTING = 'Painting',
    ROOFING = 'Roofing',
    SIDING = 'Siding',
    WINDOWS = 'Windows',
    GUTTERS = 'Gutters',
    FLOORING = 'Flooring',
    PLUMBING = 'Plumbing',
    ELECTRICAL = 'Electrical',
    HVAC = 'Hvac',
    LANDSCAPING = 'Landscaping',
    PEST_CONTROL = 'PestControl',
    FENCING = 'Fencing',
    DECKS = 'Decks',
    CONCRETE = 'Concrete',
    MASONRY = 'Masonry',
    REMODELING = 'Remodeling',
    CLEANING = 'Cleaning',
    HANDYMAN = 'Handyman',
    SOLAR = 'Solar',
    POOLS = 'Pools',
    GARAGE_DOORS = 'GarageDoors',
    TREE_SERVICE = 'TreeService',
    PRESSURE_WASHING = 'PressureWashing',
    INSULATION = 'Insulation',
    DRYWALL = 'Drywall',
    FOUNDATION = 'Foundation',
    IRRIGATION = 'Irrigation',
    OTHER = 'Other',
}
